import {FormEvent, useState} from "react";
import ChooseYourStarterSettings from "../../../../../model/pokemon/ChooseYourStarterSettings";
import _image_service from "../../../../../services/ImageService";
import _http_service from "../../../../../services/HttpService";

export interface ChooseYourStarterIntroProps {
    submit: (path: string) => void;
    error?: string;
    showError: (show?: boolean) => void;
}

const ChooseYourStarterIntro = (props: ChooseYourStarterIntroProps) => {

    const _early_gen_shiny_odds: number = 1 / 8192.0;
    const _late_gen_shiny_odds: number = 1 / 4096.0;

    const [state, setState] = useState<ChooseYourStarterSettings>({
        numberOfPlayers: 1,
        teamSize: 6,
        generation: 16,
        includeNfe: true,
        includeLegendary: true,
        includeMythical: true,
        includePseudoLegendary: true,
        shinyOdds: _late_gen_shiny_odds
    });

    const submitForm = (event: FormEvent<HTMLFormElement>): void => {
        props.showError(false);
        event.preventDefault();
        _http_service.startChooseYourStarterGame(state).then(id => {
            props.submit(id);
        }).catch(() => props.showError());
    }

    return <>
        <div className="choose-your-starter-intro">
            <img src={_image_service.getCdnImageSrc('chase/assets/chase_dragonite.png')}
                 alt="Chase as a Dragonite"
                 title="You should pick D-nite!"/>
            <p className="center">
                Build a Pokemon team for a twist on a standard competitive set, a challenge run for your favorite game,
                or try to build your dream team for fun! You will be presented with a randomized pool of three Pokemon
                from which you will choose only one to add to your team. Once you've made your selection, you
                will get a different set of three Pokemon until you have a full team of six. You can customize
                the pool of selectable Pokemon before starting the game. Once your team is complete, you'll be provided
                with a shareable image for the team you created!
            </p>
            <p className="center">
                This game was inspired by challenges such as those done by YouTube content creators Vintendo,
                ShadyPenguin, and Patterz.
            </p>
            <p className="center">
                Don't forget to share your team once it's complete! Have fun!
            </p>
            <form className="form-body" onSubmit={(event) => submitForm(event)}>
                <div>
                    <div className="cys-form-col-labels">
                        <label htmlFor="generation">Pool of Selectable Pokemon:</label>
                    </div>
                    <div className="cys-form-col-content">
                        <select id="generation-select"
                                name="generation"
                                value={state.generation}
                                onChange={(event) =>
                                    setState({...state, generation: +event.target.value})
                                }
                        >
                            <option value={16}>Pokemon Champions</option>
                            <option value={9}>Scarlet and Violet</option>
                            <option value={0}>All (National Dex)</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div className="cys-form-col-labels">
                        <label htmlFor="include-nfe">Include Not Fully Evolved:</label>
                    </div>
                    <div className="cys-form-col-content">
                        <input id="include-nfe-yes"
                               name="include-nfe"
                               type="radio"
                               value="true"
                               checked={state.includeNfe}
                               onChange={() => setState({...state, includeNfe: true})}
                        />
                        <label htmlFor="include-nfe-yes">Yes</label>
                        <input id="include-nfe-no"
                               name="include-nfe"
                               type="radio"
                               value="false"
                               checked={!state.includeNfe}
                               onChange={() => setState({...state, includeNfe: false})}
                        />
                        <label htmlFor="include-nfe-no">No</label>
                    </div>
                </div>
                <div>
                    <div className="cys-form-col-labels">
                        <label htmlFor="include-legendary">Include Legendary:</label>
                    </div>
                    <div className="cys-form-col-content">
                        <input id="include-legendary-yes"
                               name="include-legendary"
                               type="radio"
                               value="true"
                               checked={state.includeLegendary}
                               onChange={() => setState({...state, includeLegendary: true})}
                        />
                        <label htmlFor="include-legendary-yes">Yes</label>
                        <input id="include-legendary-no"
                               name="include-legendary"
                               type="radio"
                               value="false"
                               checked={!state.includeLegendary}
                               onChange={() => setState({...state, includeLegendary: false})}
                        />
                        <label htmlFor="include-nfe-no">No</label>
                    </div>
                </div>
                <div>
                    <div className="cys-form-col-labels">
                        <label htmlFor="include-mythical">Include Mythical:</label>
                    </div>
                    <div className="cys-form-col-content">
                        <input id="include-mythical-yes"
                               name="include-mythical"
                               type="radio"
                               value="true"
                               checked={state.includeMythical}
                               onChange={() => setState({...state, includeMythical: true})}
                        />
                        <label htmlFor="include-mythical-yes">Yes</label>
                        <input id="include-mythical-no"
                               name="include-mythical"
                               type="radio"
                               value="false"
                               checked={!state.includeMythical}
                               onChange={() => setState({...state, includeMythical: false})}
                        />
                        <label htmlFor="include-mythical-no">No</label>
                    </div>
                </div>
                <div>
                    <div className="cys-form-col-labels">
                        <label htmlFor="shiny-odds">Shiny Odds:</label>
                    </div>
                    <div className="cys-form-col-content">
                        <select id="shiny-odds-select"
                                name="shiny-odds"
                                value={state.shinyOdds}
                                onChange={(event) =>
                                    setState({...state, shinyOdds: +event.target.value})
                                }
                        >
                            <option value={_late_gen_shiny_odds}>Current Odds (1 in 4096)</option>
                            <option value={_early_gen_shiny_odds}>Old Odds (1 in 8192)</option>
                            <option value={0.5}>Coin Flip (1 in 2)</option>
                            <option value={1}>Always Shiny</option>
                            <option value={0}>Never Shiny</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div className="cys-form-buttons">
                        <input type="submit"
                               value="Let's go!"/>
                    </div>
                </div>
                {props.error && <div className="cys-form-col-content">
                    <span className="form-warning">
                        {props.error}
                    </span>
                </div>}
            </form>
        </div>
    </>;
}

export default ChooseYourStarterIntro;